import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const PadlockIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 34,
  height = 34,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <g
        fill="none"
        fillRule="evenodd"
        stroke="none"
        strokeWidth="1"
        transform="translate(4.000000, 1.000000)"
      >
        <path
          d="M16,19.594392 C16,17.6093837 14.4328802,16 12.5,16 C10.5671198,16 9,17.6093837 9,19.594392 C9,21.0643161 9.86137072,22.3245419 11.0914755,22.8813622 L11.0914755,25.5351656 C11.0914755,26.3444383 11.7298216,27 12.517842,27 C13.3058624,27 13.9442084,26.3444383 13.9442084,25.5351656 L13.9442084,22.8599852 C15.1544888,22.2950213 16,21.0490468 16,19.594392"
          fill="#E81C30"
          className={styles.accentColor}
        />
        <path
          d="M20.6560015,10 L4.34441305,10 C1.94492546,10 0.000700000001,11.9801204 0.000700000001,14.4226701 L0.000700000001,27.5773299 C0.000700000001,30.0198796 1.94492546,32 4.34441305,32 L20.6560015,32 C23.0554891,32 25.0007,30.0198796 25.0007,27.5773299 L25.0007,14.4226701 C25.0007,11.9801204 23.0554891,10 20.6560015,10 M20.6560015,12.006201 C21.9646338,12.006201 23.0298683,13.0905526 23.0298683,14.4226701 L23.0298683,27.5773299 C23.0298683,28.9094474 21.9646338,29.993799 20.6560015,29.993799 L4.34441305,29.993799 C3.0357808,29.993799 1.97153169,28.9094474 1.97153169,27.5773299 L1.97153169,14.4226701 C1.97153169,13.0905526 3.0357808,12.006201 4.34441305,12.006201 L20.6560015,12.006201"
          fill="#000000"
          className={styles.defaultColor}
        />
        <path
          d="M12.5,0 C16.5738269,0 19.8709978,3.38258722 19.9963055,7.58218298 L20,7.83014102 L20,11 C20,11.5522847 19.5522847,12 19,12 C18.4871642,12 18.0644928,11.6139598 18.0067277,11.1166211 L18,11 L18,7.83014102 C18,4.59951969 15.5263293,2 12.5,2 C9.54468745,2 7.11538297,4.48039851 7.0039904,7.60582412 L7,7.83014102 L7,11 C7,11.5522847 6.55228475,12 6,12 C5.48716416,12 5.06449284,11.6139598 5.00672773,11.1166211 L5,11 L5,7.83014102 C5,3.5168909 8.34699815,0 12.5,0 Z"
          fill="#000000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
      </g>
    </Icon>
  )
}
